import React from 'react';
import { IconListCheck } from '@tabler/icons-react';
interface ConversationHistoryCardProps {
  title: string;
  childName: string;
  childAvatar: string;
  date: string;
  category: string;
  categoryColor: string;
  taskCount: number;
  onClick?: () => void;
}
export function ConversationHistoryCard({
  title,
  childName,
  childAvatar,
  date,
  category,
  categoryColor,
  taskCount,
  onClick
}: ConversationHistoryCardProps) {
  return <button onClick={onClick} className="w-full bg-white border border-yeppy-text border-opacity-10 rounded-2xl px-4 py-3 transition-all duration-200 active:scale-[0.98] text-left" data-id="element-115">
      {/* Category pill */}
      <div className="flex items-center gap-2 mb-2" data-id="element-116">
        <span className="inline-block px-2 py-1 rounded-full text-xs text-yeppy-text" style={{
        backgroundColor: `${categoryColor}33`
      }} data-id="element-117">
          {category}
        </span>
      </div>

      {/* Title */}
      <h3 className="font-poppins text-yeppy-text mb-3 line-clamp-2 text-[14px]" data-id="element-118">
        {title}
      </h3>

      {/* Metadata row */}
      <div className="flex items-center gap-3 flex-wrap" data-id="element-119">
        {/* Child */}
        <div className="flex items-center gap-2" data-id="element-120">
          <img src={childAvatar} alt={childName} className="w-5 h-5 rounded-full object-cover border border-yeppy-text border-opacity-10" data-id="element-121" />
          <span className="text-xs font-poppins text-yeppy-text text-opacity-70" data-id="element-122">
            {childName}
          </span>
        </div>

        {/* Date */}
        <span className="text-xs font-poppins text-yeppy-text text-opacity-70" data-id="element-123">
          {date}
        </span>

        {/* Task count */}
        <div className="flex items-center gap-1 ml-auto" data-id="element-124">
          <div className="flex items-center gap-1 text-yeppy-text text-opacity-60" data-id="element-125">
            <IconListCheck className="w-4 h-4" stroke={1.5} data-id="element-126" />
            <span className="font-poppins text-xs" data-id="element-127">{taskCount} task</span>
          </div>
        </div>
      </div>
    </button>;
}